import * as React from 'react';
import { Thunks } from 'store/utils';
import { fetchModel } from 'features/page-model/ducks/get-model';
import { ADVICE_URL } from 'common/constants';
import { Advice } from '../advice/advice';
import { AdviceList } from '../advice-list/advice-list';
import { Perevozchik } from '../perevozchik/perevozchik';
import { IzmeneniyaVGrafikahRabotyMagazinov } from '../izmeneniya-v-grafikah-raboty-magazinov/izmeneniya-v-grafikah-raboty-magazinov';
import { ServiceProverkaTehniki } from '../service/proverka-tehniki/proverka-tehniki';
import { ServiceServisnyyCentr } from '../service/servisnyy-centr/servisnyy-centr';

export type Route = {
  key: React.Key;
  component?: React.ElementType;
  path: string | string[];
  exact?: boolean;
  strict?: boolean;
  routes?: Route[];
  thunks: Thunks;
};
export type RootRoute = Route & {
  routes: Route[];
};

export const routes: RootRoute[] = [
  {
    key: 'Advice',
    component: Advice,
    path: [`${ADVICE_URL}/:type/:advice`],
    exact: false,
    strict: false,
    routes: [],
    thunks: [fetchModel()],
  },
  {
    key: 'AdviceList',
    component: AdviceList,
    path: [ADVICE_URL, `${ADVICE_URL}/:type`],
    exact: true,
    strict: false,
    routes: [],
    thunks: [fetchModel()],
  },
  {
    key: 'ServiceServisnyyCentr',
    component: ServiceServisnyyCentr,
    path: [`/service/servisnyy-centr`],
    exact: false,
    strict: false,
    routes: [],
    thunks: [fetchModel()],
  },
  {
    key: 'ServiceProverkaTehniki',
    component: ServiceProverkaTehniki,
    path: [`/service/proverka-tehniki`],
    exact: false,
    strict: false,
    routes: [],
    thunks: [fetchModel()],
  },
  {
    key: 'IzmeneniyaVGrafikahRabotyMagazinov',
    component: IzmeneniyaVGrafikahRabotyMagazinov,
    path: [`/izmeneniya-v-grafikah-raboty-magazinov`],
    exact: false,
    strict: false,
    routes: [],
    thunks: [fetchModel()],
  },
  {
    key: 'Perevozchik',
    component: Perevozchik,
    path: [`/perevozchik`],
    exact: false,
    strict: false,
    routes: [],
    thunks: [fetchModel()],
  },
];
